import { IRootStoreState } from './types'

const user = (state: IRootStoreState) => {
  return state.user
}

const parameters = (state: IRootStoreState) => (parameterName: string) => {
  return state.parameters && state.parameters[parameterName]
}

const existUser = (state: IRootStoreState) => {
  return !!state.user
}

const existParameters = (state: IRootStoreState) => {
  return !!state.parameters
}

const isLoadingApp = (state: IRootStoreState) => {
  return state.isLoadingApp
}

const globalError = (state: IRootStoreState) => {
  return state.globalError
}

const isThereWorkToBeSaved = (state: IRootStoreState) => {
  return state.isThereWorkToBeSaved
}

const actionToHandleUnsavedWork = (state: IRootStoreState) => {
  return state.actionToHandleUnsavedWork
}

const shouldShowConfirmRouteChangeDialog = (state: IRootStoreState) => {
  return state.displayContirmRouteChangeDialog
}

const pathToGoIfModalIsConfirmed = (state: IRootStoreState) => {
  return state.pathToGoIfModalIsConfirmed
}

export default {
  user,
  parameters,
  existUser,
  existParameters,
  isLoadingApp,
  globalError,
  isThereWorkToBeSaved,
  actionToHandleUnsavedWork,
  shouldShowConfirmRouteChangeDialog,
  pathToGoIfModalIsConfirmed,
}
